import * as update from "immutability-helper";
import * as DTOS from "../FeralScan.dtos";
import { CREATE_PLOT_SUCCESS } from "../actions/dashboard.actions";
import { HIDE_PLOT_REQUEST, MapAction, SHOW_EVENT_REQUEST, SHOW_PLOT_REQUEST, TOGGLE_MAP_OPTIONS, TOGGLE_MARKER_POPUP_REQUEST, TOGGLE_NEW_MARKER_POPUP_REQUEST, ToggleNewMarkerPopupRequestAction, cacheMapSettingsAction, ICacheMapSettingsAction, CACHE_MAP_SETTINGS } from "../actions/map.actions";
import { LOCATION_CHANGE } from "connected-react-router";

export interface LatLong {
    latitude: number,
    longitude: number
}

export enum MapType {
    normal = "normal",
    clustered = "clustered",
    heat = "heat"
}

export type MapState = {
    defaultLatitude?: number;
    defaultLongitude?: number;
    defaultZoom?: number;
    openMarkers: any[];
    openNewMarker: LatLong;
    openMapOptions: any;
    saving: boolean;
    showPlotEvent: boolean;
    showMarker: boolean;
    cachedZoom?: number;
    cachedLatLong?: LatLong;
}

const initialState: MapState = {
    openNewMarker: undefined,
    openMarkers: [],
    openMapOptions: {
        'MapType': false,
        'Legend': false,
        'Layers': false
    },
    saving: true,
    showPlotEvent: false,
    showMarker: false,
};

export default function survey(state: MapState = initialState, action) {
    switch (action.type) {
        case HIDE_PLOT_REQUEST:
            return showPlotMarker(state, action);
        case SHOW_PLOT_REQUEST:
            return showPlotMarker(state, action);
        case SHOW_EVENT_REQUEST:
            return showEventDetail(state, action);
        case CREATE_PLOT_SUCCESS:
            return showPlotMarker(state, action);
        case TOGGLE_NEW_MARKER_POPUP_REQUEST:
            return toggleNewMarkerPopup(state, action);
        case TOGGLE_MARKER_POPUP_REQUEST:
            return toggleMarkerPopup(state, action);
        case TOGGLE_MAP_OPTIONS:
            return toggleMapOptions(state, action);
        case LOCATION_CHANGE:
            return closeAllMarkerPopups(state);
        case CACHE_MAP_SETTINGS:
            return cacheMapSettings(state, action);
            
    }
    return state;
}

function showPlotMarker(state: MapState, action: MapAction): MapState {
    let showMarker = action.plot ? true : false;

    const newState = update(state, {
        openNewMarker: { $set: undefined }
    });

    if (!showMarker) {
        return update(newState,
            {
                showMarker: { $set: showMarker },
            });
    } else {
        return update(newState,
            {
                showMarker: { $set: showMarker },
                defaultLatitude: { $set: action.plot.latitude },
                defaultLongitude: { $set: action.plot.longitude },
                defaultZoom: { $set: 16 },
            });
    }
}

function hideEventDetail(state: MapState, action: MapAction) {
    return update(state, {
        showPlotEvent: { $set: false },
        plot: { $set: undefined },
        showMarker: { $set: false }
    });
}

function showEventDetail(state: MapState, action: MapAction): MapState {
    let showPlotEvent = action.plot ? !state.showPlotEvent : false;
    return update(state,
        {
            showPlotEvent: { $set: showPlotEvent },
            plot: { $set: action.plot },
        });
}

function savingData(state, saving) {
    let newState = update(state, { saving: { $set: saving } });
    return newState;
}

function closeAllMarkerPopups(state: MapState) {
    let newState = update(state, {
        openNewMarker: { $set: undefined },
        openMarkers: { $set: [] }
    });

    return newState;
}

    
function toggleNewMarkerPopup(state: MapState, action: ToggleNewMarkerPopupRequestAction) {

    
    const newMarker: LatLong = action.latitude && action.longitude ? {
        latitude: action.latitude,
        longitude: action.longitude
    } : undefined

    let newState = update(state, {
        openNewMarker: { $set: newMarker }
    });

    return newState;

    //let newState = update(state, { $toggle: ['showNewMarker'] });
    //return newState;
}

function toggleMarkerPopup(state, marker) {
    const newMarkers: number[] = [];

    newMarkers.push(marker.marker);

    if (state.openMarkers.includes(marker.marker)) {

        const index = state.openMarkers.indexOf(marker.marker);

        let newState = update(state, {
            openMarkers: { $splice: [[index, 1]] }
        });
        return newState;
    } else {
        let newState = update(state, {
            openMarkers: { $push: newMarkers }
        });
        return newState;
    }
}

function toggleMapOptions(state, action) {
    let newState = update(state, {
        openMapOptions: { $toggle: [action.mapOption] }
    });
    return newState;
}

function cacheMapSettings(state, action: ICacheMapSettingsAction) {
    const newState = update(state, {
        cachedZoom: { $set: action.zoom },
        cachedLatLong: { $set: action.location }
    })

    return newState;
}